import $ from 'jquery';
import { Tab } from 'bootstrap';
import type { IDonation } from '../types';

export class DonationTabs {
    private donation: IDonation;
    private donationflow: HTMLElement;
    private triggerTabList: HTMLElement[] = [];
    private currentStep = 0;
    private onpayment = false;

    constructor(donation: IDonation) {
        this.donation = donation;
        this.donationflow = donation.DonationElement;
        this.initTabEvents();
    }

    get currentTabStep(): number {
        return this.currentStep;
    }

    get onPayment(): boolean {
        return this.onpayment;
    }

    private initTabEvents(): void {
        this.triggerTabList = [].slice.call(this.donationflow.querySelectorAll('button[data-step]'));
        this.triggerTabList.forEach(triggerEl => {
            const tabTrigger = Tab.getOrCreateInstance(triggerEl);
            triggerEl.addEventListener('click', evt => {
                evt.preventDefault();
                tabTrigger.show();
            });

            triggerEl.addEventListener('show.bs.tab', evt => {
                const btn = $(evt.target as HTMLElement);
                const tabname = btn.closest('.tab-pane').attr('id');
                const nextstep = parseInt(btn.data('step') as string);

                if (this.donation.CurrentProgress < nextstep) {
                    if (tabname === 'tab-giftform' && !this.donation.GiftFormValid) {
                        evt.preventDefault();
                        this.donationflow.dispatchEvent(new CustomEvent('donationerror', { detail: { error: 'Vänligen kontrollera formuläret' } }));
                        return;
                    } else if (tabname === 'tab-amount' && this.donation.Amount < 100) {
                        evt.preventDefault();
                        this.donationflow.dispatchEvent(new CustomEvent('donationerror', { detail: { error: 'Beloppet måste vara minst 100kr' } }));
                        return;
                    } else if (tabname === 'tab-paymentoptions' || tabname === 'tab-delivery') {
                        if (!this.donation.DeliverOptionsValid) {
                            evt.preventDefault();
                            this.donationflow.dispatchEvent(new CustomEvent('donationerror', { detail: { error: 'Vänligen kontrollera leveransalternativen' } }));
                            return;
                        }
                        if (!this.donation.PaymentValid) {
                            evt.preventDefault();
                            this.donationflow.dispatchEvent(new CustomEvent('donationerror', { detail: { error: 'Vänligen kontrollera betalningsalternativen' } }));
                            return;
                        }
                    }
                }

                this.triggerTabList.forEach(el => {
                    if (!el.isSameNode(evt.target as Node)) $(el).removeClass('active');
                });

                this.currentStep = nextstep;
                this.onpayment = btn.data('alz-payment') === true;
                this.donationflow.dispatchEvent(new CustomEvent('stepchanged', { detail: { step: nextstep } }));
            });
        });
    }
}
